import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';

const PaymentsForm = ({ formInput }) => {
  const content = JSON.stringify(formInput, null, 2);
  return (
    <Fragment>
      <div className="bg-black text-white p-4">
        <pre>
          {content}
        </pre>
      </div>
    </Fragment>
  );
};

PaymentsForm.propTypes = {
  // One log row. Declared as an array until the container started passing the row it
  // actually renders - before that this only ever received undefined, so nothing ever
  // contradicted the type.
  formInput: PropTypes.shape({}),
};

PaymentsForm.defaultProps = {
  formInput: null,
};

export default PaymentsForm;
